import { QueryResult, useQuery, OperationVariables, ApolloError } from '@apollo/client';
import GET_CURRICULUM_ASSESSMENTS from 'graph/queries/assessments/get-curriculums-assessments';
import { Assessment, StoreTypename } from 'types';

export type AvailableAssessmentsStoreState = {
  assessments: Assessment[];
  isLoading: boolean;
  error?: ApolloError;
};

export type AvailableAssessmentsStoreDispatch = {
  availableAssessmentsRefetch: any;
};

export type AvailableAssessmentsStore = [
  AvailableAssessmentsStoreState,
  AvailableAssessmentsStoreDispatch
];

export const getDefaultCurriculumAssessmentsStoreState = (): any => ({
  __typename: StoreTypename.CURRICULUM_ASSESSMENTS,
});

const useAvailableAssessmentsStore = (): AvailableAssessmentsStore => {
  const {
    data,
    loading,
    error,
    refetch: availableAssessmentsRefetch,
  }: QueryResult<{ assessments: Assessment[] }> = useQuery(GET_CURRICULUM_ASSESSMENTS, {
    variables: { assessmentsWhere: {} } as OperationVariables,
  });

  return [
    {
      assessments: data?.assessments ?? [],
      isLoading: loading,
      error,
    },
    {
      availableAssessmentsRefetch,
    },
  ];
};

export default useAvailableAssessmentsStore;
